export default __webpack_public_path__ + "media/images/carousel/11-db82b46800d7186c6ba759000a2e5185.jpg";